//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { VerificacionInterface } from "../../../../interfaces/VerificacionInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./VerificacionTable.module.css").default;

const VerificacionTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [verificacion, setVerificacion] = useState<VerificacionInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los verificacion traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setVerificacion(variable.data);
  }, []);

  //Función que llama todos los verificacion paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/verificacion",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un verificacion.
  const changeVerificacionStatus = useCallback(
    (idVerificacion: number) => {
      if (
        window.confirm(
          "¿Seguro que desea cambiar el estatus de la verificación?"
        )
      ) {
        sendRequest(
          {
            url: `/verificacion/${idVerificacion}`,
            method: "DELETE",
          },
          (variable: any) => {
            setVerificacion([]);
            toast.success("La verificación ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/verificacion",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<VerificacionInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar verificación"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/verificacion/edit/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("Verificacion:update")}
            >
              <FontAwesomeIcon icon={faPen as IconProp} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar verificación"
                  : "Habilitar verificación"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("Verificacion:delete")}
              onClick={() => changeVerificacionStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={(info.row.original.estatus ? faToggleOn : faToggleOff) as IconProp}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changeVerificacionStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!verificacion) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de verificaciones</h2>
      {/** Botón para agregar verificación */}
      {authContext.tokenCan("Verificacion:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva verificación"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/verificacion/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus as IconProp} /> Nueva verificación
          </Button>
        </div>
      )}

      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: verificacion,
          columns,
        }}
      />
    </Container>
  );
};

export default VerificacionTable;
